import { apiDirectCall } from "customHooks/useApi/api";
import { useGlobalDialog } from "_ReactContext/GlobalDialogContext";
import { navigate } from "@gatsbyjs/reach-router";

const useNextPageFunctionsNewJob = (
    companyId: number,
    t: any,
    isEdit: boolean = false
) => {
    const { readyForm, callDialog, agree } = useGlobalDialog();

    const verifyExternalCode = async (nextPageFunction: any, values: any) => {
        if (!values.externalCode || isEdit) {
            nextPageFunction();
        } else {
            const params = {
                fieldValueToValidate: values.externalCode,
                companyId,
                validationType: "jobExternalCodeExists"
            };
            const url = "/general/genericvalidationlogged";
            const validation = await apiDirectCall(url, "post", params);
            const valid = validation.data.validationResult;

            if (!valid) {
                callDialog({
                    title: t("externalCodeExists_ModalTitle"),
                    bodyText: t("externalCodeExists_Message"),
                    agreeButtonText: t("externalCodeExists_Yes"),
                    disagreeButtonText: t("externalCodeExists_No"),
                    agreeFunction: async () => {
                        const searchJobUrl = "/job/search-by-external-code";
                        const jobData = await apiDirectCall(
                            searchJobUrl,
                            "post",
                            {
                                externalCode: values.externalCode,
                                companyId: companyId
                            }
                        );
                        console.log("jobData", jobData);
                        if (jobData.data?.id) {
                            const jobId: string = jobData.data.id;
                            navigate(`/job/edit/${jobId}`);
                        }
                    },
                    disagreeFunction: () => {}
                });
            } else {
                nextPageFunction();
            }
        }
    };

    const nextPageFunctions = [{ page: 1, fn: verifyExternalCode }];

    return nextPageFunctions;
};

export default useNextPageFunctionsNewJob;
